import filter from './filter/filter'
import sort from './sort/sort'

export default function(p){

  return function(){

    var rows = p.data
    var sorters = p.sorters
    var filters = p.filters

    var filteredRows = filter(rows,filters)
    var sortedRows = sort(filteredRows,sorters)

    var totalRows = sortedRows.length

    p.footer.set(totalRows+' rows')
    p.rows.update(sortedRows)

    requestAnimationFrame(p.layout)

  }

}



// WEBPACK FOOTER //
// ./src/client/view/admin/search/table/lib/update/update.js